import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="new-template"
export default class extends Controller {
  static targets = ["title", "handle", "html", "jsonLabel"];

  fileSelected(event) {
    for (const file of event.target.files) {
      this.jsonLabelTarget.innerText = file.name;
      console.log(getExtension(file.name));
      let extension = getExtension(file.name);
      const reader = new FileReader();
      reader.onload = () => {
        if (extension == "json") {
          let results = JSON.parse(reader.result);
          this.titleTarget.value = results["title"];
          this.handleTarget.value = results["handle"];
          this.htmlTarget.value = results["html"];
        } else {
          let name = file.name.slice(0, file.name.lastIndexOf(`.${extension}`));
          this.titleTarget.value = name;
          this.handleTarget.value = name;
          this.htmlTarget.value = reader.result;
        }
      };
      reader.readAsText(file);
    }
  }
}

function getExtension(path) {
  var basename = path.split(/[\\/]/).pop(), // extract file name from full path ...
    // (supports `\\` and `/` separators)
    pos = basename.lastIndexOf("."); // get last position of `.`

  if (basename === "" || pos < 1)
    // if file name is empty or ...
    return ""; //  `.` not found (-1) or comes first (0)

  return basename.slice(pos + 1); // extract extension ignoring `.`
}
